const WS_URL =
    window.__ENV__?.WS_URL || "wss://socket.smbet.net";

console.log("WS URL =>", WS_URL);

export { WS_URL };